import { NetworkIdentity } from "./NetworkIdentity";

export class NetowrkPathTranslator {
	public static DEV_SERVER_BASE_URL = "http://localhost:8080";
	public static PROD_SERVER_BASE_URL = `https://${location.host}`;

	public static get SERVER_BASE_URL() {
		return process.env.NODE_ENV !== "production"
			? NetowrkPathTranslator.DEV_SERVER_BASE_URL
			: NetowrkPathTranslator.PROD_SERVER_BASE_URL;
	}
	public static getRestApiPath(path: string): string {
		if (path.startsWith("http")) {
			return path;
		}
		if (path.startsWith("/")) {
			path = path.substring(1);
		}
		if (path.startsWith("rest/")) {
			path = path.substring("rest/".length);
		}

		const remotePath = `${NetowrkPathTranslator.SERVER_BASE_URL}/rest/${path}`;
		return remotePath;
	}

	private static _addTokenToUrl(url: string, addToken: boolean): string {
		if (!addToken) {
			return url;
		}

		const token = `${NetworkIdentity.tokenName}=${NetworkIdentity.backendToken}`;
		if (url.includes("?")) {
			return `${url}&${token}`;
		} else {
			return `${url}?${token}`;
		}
	}
	// TODO :: implement adding token from NetworkIdentity
	public static getRemotePath(path: string, addToken = false): string {
		if (path.startsWith("http")) {
			return this._addTokenToUrl(path, addToken);
		}
		if (path.startsWith("/")) {
			path = path.substring(1);
		}
		const remotePath = this._addTokenToUrl(`${NetowrkPathTranslator.SERVER_BASE_URL}/rest/files/${path}`, addToken);
		return remotePath;
	}
	public static getStaticPath(path: string): string {
		if (path.startsWith("http")) {
			return path;
		}
		if (path.startsWith("/")) {
			path = path.substring(1);
		}
		const remotePath = `${NetowrkPathTranslator.SERVER_BASE_URL}/${path}`;
		return remotePath;
	}
}
